<template>
  <div class="thirdSectionContainer">
    <div class="powerBall">
      <p>
        <span v-if="this.langChosen === 'gr'">핫 넘버</span>
        <span v-else>Hot Number</span>
      </p>

      <div class="ballContainer">
        <div class="eachBall">{{ hotColdData[0] }}</div>
        <div class="eachBall">{{ hotColdData[1] }}</div>
        <div class="eachBall">{{ hotColdData[2] }}</div>
      </div>
    </div>

    <div class="weakBall">
      <p>
        <span v-if="this.langChosen === 'gr'">콜드 넘버</span>
        <span v-else>Cold Number</span>
      </p>

      <div class="ballContainer">
        <div class="eachBall">{{ hotColdData[3] }}</div>
        <div class="eachBall">{{ hotColdData[4] }}</div>
        <div class="eachBall">{{ hotColdData[5] }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.getHotColdData();
  },

  methods: {
    getHotColdData() {
      fetch(`/api/hotCold`).then(response => {
        if (response.ok) {
          response.json().then(res => {
            this.hotColdData = res;
          });
        } else {
          alert('Terjadi kesalahan ketika mengambil data.');
        }
      });
    },
  },

  data: function() {
    return {
      hotColdData: [],
    };
  },
};
</script>

<style>
.thirdSectionContainer {
  background-color: var(--darkColor);
  display: flex;
  justify-content: space-evenly;
  padding-top: 15px;
  padding-bottom: 15px;
}

.powerBall,
.weakBall {
  width: 48.5%;
  text-align: center;
  font-weight: bold;
  padding: 20px 0;
  color: var(--lightColor);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.ballContainer {
  display: flex;
  justify-content: space-evenly;
  width: 80%;
  margin-top: 10px;
}

.eachBall {
  border-radius: 50%;
  width: 10vw;
  height: 10vw;
  min-width: 40px;
  min-height: 40px;
  max-width: 50px;
  max-height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  color: var(--darkColor);
  font-size: 110%;
}

.powerBall > .ballContainer > .eachBall {
  background-color: #a40606;
  background-image: linear-gradient(315deg, #a40606 0%, #d98324 74%);
  color: var(--lightColor);
}

.powerBall p {
  color: #d98324;
  margin: 0;
}

.weakBall > .ballContainer > .eachBall {
  background-color: #63a4ff;
  background-image: linear-gradient(315deg, #63a4ff 0%, #83eaf1 74%);
}

.weakBall p {
  color: #83eaf1;
  margin: 0;
}

@media screen and (min-width: 768px) {
  .ballContainer {
    width: 250px;
  }

  .thirdSectionContainer {
    padding-left: 150px;
    padding-right: 150px;
  }
}
</style>
